<template>
  <div>
    <el-dialog title="看法"
               :visible.sync="dialogFormVisible"
               width="1092px"
               top="10px"
               @close="handleClose()"
               @open="open()">
      <div>
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query">
          <!-- <el-form-item label="标题"
                        prop="question_title">
            <el-input v-model="query.question_title"
                      placeholder="请输入标题"
                      style="width: 200px"
                      @input="getAllOption(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="关键词"
                        prop="question_name">
            <el-input v-model="query.question_name"
                      placeholder="请输入关键词"
                      style="width: 200px"
                      @input="getAllOption(true)"
                      clearable></el-input>
          </el-form-item> -->

          <el-form-item label="状态"
                        prop="statuses">
            <el-select v-model="query.statuses"
                       placeholder="请选择"
                       clearable
                       @change="getAllOption(true)"
                       style="width:100px;">
              <el-option v-for="item in filter.status"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>

          </el-form-item>

        </el-form>

        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column type="index"
                           label="序号"
                           width="50"
                           align="center">
          </el-table-column>
          <el-table-column prop="question_title"
                           width="380"
                           label="标题"
                           align="left"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="question_name"
                           width="120"
                           label="关键字"
                           align="left"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="status"
                           width="80"
                           label="状态"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==0"
                      type="info">下线</el-tag>
              <el-tag v-if="scope.row.status==1"
                      type="success">上线</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="keyword"
                           width="90"
                           label="创建人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.create_admin_obj.nickname}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="create_time"
                           width="150"
                           label="创建时间"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="update_time"
                           width="150"
                           label="更新时间"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="120"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleEdit(scope.row)"
                       style="marginRight:10px"><span class="cao">编辑</span></el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleDelete(scope.row)"><span class="cao">删除</span></el-link>
              <!-- </template> -->
            </template>
          </el-table-column>

        </el-table>
        <div style="display:flex;justify-content:space-between;marginTop:20px ">
          <div class="create">
            <el-tag effect="plain"
                    @click="innerVisible=true">新建看法
            </el-tag>

          </div>
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSize"
                         @current-change="handlePage">
          </el-pagination>

        </div>

      </div>

      <el-dialog width="43%"
                 :title="title"
                 @close="handleCancle"
                 :visible.sync="innerVisible"
                 append-to-body>
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="createForm">
          <el-form-item label="标题"
                        prop="title"
                        label-width="70px">
            <el-input v-model="createForm.question_title"
                      placeholder="请输入标题"
                      type="textarea"
                      style="width: 400px"
                      clearable>
            </el-input>
          </el-form-item>
          <div>
            <el-form-item label="关键字"
                          prop="title"
                          label-width="70px">
              <el-input v-model="createForm.question_name"
                        placeholder="请输入关键字"
                        style="width: 400px"
                        clearable></el-input>
            </el-form-item>
          </div>
          <div> <el-form-item label="发布状态"
                          prop="status"
                          label-width="70px">
              <el-switch v-model="createForm.status"></el-switch>
            </el-form-item></div>

        </el-form>

        <div class="footer">
          <div class="cancle"
               @click="handleCancle()">取消</div>
          <div class="confirm"
               @click="handleConfirm()">确认</div>
        </div>

      </el-dialog>

    </el-dialog>

  </div>
</template>
<script>
import {
  opinionList,
  createOption,
  putOption,
  cancleOption,
} from '@/api/senior'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新建看法',
      innerVisible: false,
      dialogFormVisible: this.isVisible,
      userForm: {},
      createForm: { status: false, keyword: '', title: '' },
      results: [],
      filter: {
        status: [
          {
            label: '下线',
            value: '0',
          },
          {
            label: '上线',
            value: '1',
          },
        ],
      },
      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      detail: {},
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {
    handleEdit(row) {
      this.innerVisible = true
      this.title = '编辑看法'
      this.detail = row
      this.createForm.question_title = row.question_title
      this.createForm.question_name = row.question_name
      this.createForm.status = row.status == 1 ? true : false
    },
    handleDelete(row) {
      this.$confirm('确定要删除这条看法吗？', '提示', {
        confirmButtonText: '确定删除',
        type: 'warning',
      }).then((res) => {
        cancleOption({ id: row.id }).then((res) => {
          this.$message.success('删除成功!')
          this.getAllOption()
        })
      })
    },
    handleConfirm() {
      let data = {
        question_title: this.createForm.question_title,
        question_name: this.createForm.question_name,
        status: this.createForm.status ? 1 : 0,
        sort:999
      }
      if (this.title == '新建看法') {
        createOption(data).then((res) => {
          this.innerVisible = false
          this.$message.success('操作成功!')
          this.getAllOption()
        })
      } else if (this.title == '编辑看法') {
        data.id = this.detail.id
        putOption(data).then((res) => {
          this.innerVisible = false
          this.$message.success('操作成功!')
          this.getAllOption()
        })
      }
    },
    handleCancle() {
      this.createForm = { status: false, question_name: '', question_title: '' }
      this.innerVisible = false

      this.title = '新建看法'
    },
    createOption() {},
    //获取所有看法
    getAllOption(reset) {
      if (reset) {
        this.query.pageIndex = 1
      }
      opinionList(this.query).then((res) => {
        this.pageTotal = res.count
        this.results = res.list
      })
    },

    handleClose() {
      this.$emit('close')
    },
    handleSize(val) {
      this.$set(this.query, 'pageSize', val)
      this.getAllOption()
    },
    handlePage(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getAllOption()
    },
    open() {
      this.getAllOption()
    },
  },
}
</script>
<style scoped lang="less">
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
.footer {
  display: flex;
  justify-content: flex-end;
  .cancle {
    width: 56px;
    text-align: center;
    height: 36px;
    font-weight: 400;
    font-size: 14px;
    line-height: 36px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
    margin-right: 20px;
  }
  .confirm {
    width: 56px;
    text-align: center;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    color: #fff;
    background: #1f86fe;
    border-radius: 4px 4px 4px 4px;
  }
}
</style>